export const scopes = [];

export const msalConfig = {
  auth: {
    clientId: "",
    authority: "",
    knownAuthorities: [] as string[],
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  redirectStartPage: "/",
  scopes: scopes,
};

export const logoutRequest = {
  postLogoutRedirectUri: "/",
  scopes,
};

export const sessionTimeoutConfig = {
  timeout: 1_200_000, // 20 mins
  promptBeforeIdle: 60_000, // 1 min
};
